/* Quick "Add To Bag" button used by the shared .jpc product card (snippets/jaypore-card.liquid).
   Event delegation so it works for cards injected later too. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jp-add-to-bag]');
    if (!btn || btn.disabled) return;
    var variantId = btn.getAttribute('data-jp-add-to-bag');
    if (!variantId) return;

    var original = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = 'Added!';
        return fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.header-top-bar__cart-badge').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function () {
        btn.textContent = original;
        btn.disabled = false;
      });
  });
})();
